/**
 * @file チェックボックストグル
 */
'use strict';

/**
 * @classname ToggleCheck
 * @classdesc チェックボックストグル
 */
export default class ToggleCheck {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ToggleCheck.constructor');
		this._$e = $e;
		this._$target = $e.closest('.form-group').find('.toggle-target');
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof ToggleCheck
	 * @return {undefined}
	 */
    onClick() {
		console.log('ToggleCheck.onClick');
		$('.toggle-check').each((idx, e) => {
		    const $e = $(e);
		    $e.removeClass('is-invalid')
                .closest('.form-group')
                .find('.error-tip')
                .removeClass('show')
                .find('.error-tip-inner')
                .text('');
        });
		if(this._$e.prop('checked')){
		    this._$target.slideDown();
		    this._$target.find('.validate').removeClass('ignore-validate');
        }else{
            this._$target.slideUp();
            this._$target.find('.validate').removeClass('ignore-validate').val();
            this._$target.find('.error-tip').removeClass('show').children('.error-tip-inner').html('');
            this._$target.find('input[type=checkbox]').prop('checked', false);
			// 影響範囲を限定（shopshowのblade）するためにif文
			if(this._$target.find('.validate-toggle').length) {
				this._$target.find('.validate-toggle').addClass('ignore-validate').removeClass('is-invalid').val('');
			}
        }
	};
}
